import React from "react";
import { keyBy } from "lodash";
import { format } from "date-fns";

import { DateFormat } from "utilities/dist/invoice/constants";
import { parseServerTimestampForClient } from "../../common/helpers";
import { formatAmount } from "utilities/dist/helpers";
import { InvoiceLinkRenderer, InvoiceEmptyRenderer } from "../grid/cellRenderers.component";

export const allGridColumns = keyBy(
    [
        {
            field: "number",
            headerName: "Invoice",
            cellRenderer: InvoiceLinkRenderer,
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: function ({ data }) {
                return data && data.invoice ? data.invoice.number : null;
            },
        },
        {
            field: "received_at",
            headerName: "Date",
            filter: "agDateColumnFilter",
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            valueGetter: ({ data }) => {
                return data && data.received_at
                    ? format(parseServerTimestampForClient(data.received_at), DateFormat)
                    : null;
            },
        },
        {
            field: "customer",
            headerName: "Customer",
            pinnedRowCellRenderer: InvoiceEmptyRenderer,
            cellRenderer: function ({ data }) {
                if (!data || !data.invoice) return null;
                return (
                    <>
                        {data.invoice.customer.name}
                        <br />
                        {data.invoice.customer.address}
                    </>
                );
            },
            valueGetter: function ({ data }) {
                return data && data.invoice
                    ? `${data.invoice.customer.name}, ${data.invoice.customer.address}`
                    : null;
            },
            filter: "agTextColumnFilter",
        },
        {
            field: "amount",
            headerName: "Amount",
            type: "numericColumn",
            filter: "agNumberColumnFilter",
            valueGetter: function ({ data }) {
                if (!data) return null;
                return formatAmount(data.amount);
            },
        },
    ],
    "field"
);
